export enum SignInError {
    es = "Un error ha ocurrido mientras intentamos iniciar su sesion en nuestro sistema, favor de hacerlo manualmente.",
    pt = "Ocorreu um erro enquanto tentávamos fazer login em nosso sistema, faça login manualmente",
    en = "An error has occurred while we tried to SignIn in our system, please SignIn manually"
}